// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code_container[data-v-6ea6c295] {\n  padding: 70px 50px 50px 50px;\n}\n.code_container__info[data-v-6ea6c295] {\n  margin-bottom: 50px;\n  font-size: 1.5em;\n}\n.code_container__button[data-v-6ea6c295] {\n  margin-top: 30px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
